import React from 'react';
import clsx from 'clsx';
import useStyles from './styles/iconStyle';
import { createStyles, makeStyles } from '@material-ui/core';
import { CommonIconProps } from './common/types';

const useApsyIconClasses = makeStyles((theme) =>
    createStyles({
        greenPart: {
            fill: theme.palette.primary.main
        },
        blackPart: {
            fill: theme.palette.grey.A400
        },
        greyPart: {
            fill: theme.palette.text.disabled
        }
    })
);

const ApsyIcon = ({ className, ...rest }: CommonIconProps) => {
    const classes = useStyles();
    const apsyClasses = useApsyIconClasses();
    return (
        <svg
            className={clsx(classes.root, className)}
            {...rest}
            id="mdi-close-circle-outline"
            viewBox="0 0 116.909 30.709">
            <g id="Apasy_Logo_Neo_Dark" data-name="Apasy Logo Neo Dark">
                <path
                    className={apsyClasses.greenPart}
                    d="M49.58,0c.84.24,1.71.36,2.55.66a11.12,11.12,0,0,1,7,9.51,11,11,0,0,1-6.51,10.67,8.53,8.53,0,0,1-3.51.83c-3,0-5.93,0-8.89,0-.47,0-.57.14-.56.58,0,1.38,0,2.77,0,4.16a3.07,3.07,0,0,1-2.53,3,3.18,3.18,0,0,1-3.6-2,3.24,3.24,0,0,1-.17-1.12c0-3.4,0-6.8,0-10.2,0-.47.14-.56.57-.56,4.69,0,9.38,0,14.07,0a4.76,4.76,0,0,0,4.74-3.21A4.71,4.71,0,0,0,48,6.21a12.5,12.5,0,0,1-3.29.09,3,3,0,0,1-2.44-3.44A3,3,0,0,1,45.13.11c.37-.12.77.05,1.14-.1Z"
                />
                <path
                    className={apsyClasses.greenPart}
                    d="M15.51,0A4.25,4.25,0,0,1,18,2.49C19,4.37,19.86,6.24,20.9,8c1.8,3.11,3.33,6.35,5,9.53a3,3,0,0,1-1.76,4.34,3.33,3.33,0,0,1-3.87-1.59c-1.48-2.87-3-5.73-4.52-8.59l-.84-1.61c-.21.09-.23.29-.31.45-2.41,4.79-4.8,9.58-7.25,14.34-.51,1-1,2-1.56,2.93a3,3,0,0,1-2.87,1.51A2.93,2.93,0,0,1,.25,27.43C.16,27.23.09,27,0,26.81V25.67a4.29,4.29,0,0,1,.52-1.48c2-4,3.93-8,6-12C8.39,8.7,10.18,5.15,12,1.6A2.82,2.82,0,0,1,14.25,0Z"
                />
                <path
                    className={apsyClasses.greenPart}
                    d="M63.47,7.76a8.73,8.73,0,0,1,4.21-5.69,14.82,14.82,0,0,1,14.88.22c.41.27.81.56,1.2.86a2.7,2.7,0,0,1,.67,3.52,2.71,2.71,0,0,1-3.55,1,3.32,3.32,0,0,1-.53-.33C77.83,5.29,75,5.15,72.06,6a7.53,7.53,0,0,0-1.94.93,2.26,2.26,0,0,0,.21,4,8.71,8.71,0,0,0,3.74.83,28.34,28.34,0,0,1,6.43.7,9,9,0,0,1,5.56,4.15,7.11,7.11,0,0,1,.49,5.47c-1.08,4.3-4.17,6.33-8.25,7.11a15,15,0,0,1-8.14-.49,12.83,12.83,0,0,1-6.67-5.49A2.4,2.4,0,0,1,63.17,21a3.38,3.38,0,0,1,2.62-2.25,2.18,2.18,0,0,1,2,.76c.56.62,1.06,1.29,1.59,1.94A8.88,8.88,0,0,0,72,23.49a6,6,0,0,0,3.43.56,7.94,7.94,0,0,0,4.67-1.54,3.51,3.51,0,0,0,.71-.73c1.18-1.65.35-2.93-1.35-3.73a7.8,7.8,0,0,0-3.17-.59,26.16,26.16,0,0,1-6.54-.69,9.87,9.87,0,0,1-5.6-4.21,4.58,4.58,0,0,1-.59-1.47,7.37,7.37,0,0,1-.31-2.51C63.47,8.34,63.27,8,63.47,7.76Z"
                />
                <path
                    className={apsyClasses.greenPart}
                    d="M102.58,29.9H101.3a3,3,0,0,1-2.43-3.07c0-2.11,0-4.22,0-6.33a1.58,1.58,0,0,0-.26-.9c-2.31-3.68-4.57-7.38-6.93-11-.71-1.1-1.47-2.19-2.15-3.32A3,3,0,0,1,90.78.83,3.21,3.21,0,0,1,95,2.07c1.89,3.08,3.83,6.14,5.74,9.21.39.61.77,1.22,1.18,1.88.88-1.32,1.78-2.56,2.54-3.88a3.38,3.38,0,0,1,4.36-1,3.1,3.1,0,0,1,1,4.32c-1.34,2.2-2.67,4.41-4.14,6.53a3.32,3.32,0,0,0-.63,2.12c0,1.86,0,3.72,0,5.58A3,3,0,0,1,102.58,29.9Z"
                />
                <path
                    className={apsyClasses.greyPart}
                    d="M33.4,3.59a3.17,3.17,0,0,1,6.33,0,3.11,3.11,0,0,1-3.1,3.12A3.15,3.15,0,0,1,33.4,3.59Z"
                />
                <path
                    className={apsyClasses.greyPart}
                    d="M114.87,3.68a3.11,3.11,0,0,1-6.22-.12,3.11,3.11,0,1,1,6.22.12Z"
                />
                <path
                    className={apsyClasses.blackPart}
                    d="M30,26.75a3.09,3.09,0,1,1-6.17,0,3.09,3.09,0,1,1,6.17,0Z"
                />
            </g>
        </svg>
    );
};

export default ApsyIcon;
